import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { AuthBootstrap } from "@/features/auth/components/AuthBootstrap";
import "@/i18n";
import { ThemeProvider } from "@/lib/theme/ThemeProvider";
import { queryClient } from "@/lib/query/queryClient";

export interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Provider qendror per QueryClient dhe provider te tjere te aplikacionit.
 */
export const AppProviders = ({ children }: AppProvidersProps): JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthBootstrap>{children}</AuthBootstrap>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
